<template>
  <div class="mobile_register">
    <div class="mobile_register_content">
      <h2>hecoos</h2>
      <h3>To ensure that you can pass the audit quickly, please fill in thetrue
        and effective information.</h3>
      <form action="">
        <input v-model="form.rname" type="text" placeholder="Name">
        <div class="get_code">
          <input class="code_inp" v-model="form.email" type="email" placeholder="E-mail">
          <button :disabled="!isPhoneValid || isCountingDown" class="code_btn" @click="getCode">{{ isCountingDown ?
            ` ${countdown}s` : "Get" }}</button>
        </div>
        <input v-model="form.verifyCode" type="text" placeholder="Verify code">
        <input v-model="form.password" type="password" placeholder="Password">
        <input v-model="form.confirmPassword" type="password" placeholder="Re-enter password">

        <input v-model="form.company" type="text" placeholder="Company">
        <input v-model="form.city" type="text" placeholder="City">
        <input v-model="form.position" type="text" placeholder="Job">
<!--        <input v-model="form.workDuration" type="text" placeholder="Seniority">-->

        <select  placeholder="Seniority" :class="{'none_select' : !this.form.workDuration}" v-model="form.workDuration">
          <option value="" disabled selected>Seniority</option>
          <option v-for="item in workDurationList" :value="item.name">{{item.name}}</option>
        </select>
        <input v-model="form.referrer" type="text" placeholder="Referrer (optional)">


        <button :disabled="!isButtonEnabled" type="button" @click="handleSubmit">Submit</button>
      </form>
      <p>
        <!-- <span @click="jumpTo('/en')">回首页</span>丨 -->
        <span @click="jumpTo('/en/login')">Already have an account? Log in</span>
      </p>
    </div>
  </div>
</template>
<script>
import { adminRegister, getCaptcha,getEnglishCaptcha } from "@/api/api"
import { Message } from "element-ui";
export default {
  data() {
    return {
      form: {
        rname: "",

        verifyCode: "",
        password: "",
        confirmPassword: "",
        email: "",
        company: "",
        city: "",
        position: "",
        workDuration: "",
        referrer: "",
      },
      isCountingDown: false,
      countdown: 60,
      errorMessages: [], // 新增：收集所有错误信息

      workDurationList:[
        {name:'1years'},
        {name:'2years'},
        {name:'3years'},
        {name:'4years'},
        {name:'5years'},
        {name:'6years'},
        {name:'7years'},
        {name:'8years'},
        {name:'9years'},
        {name:'More than 10 years'}
      ]
    };
  },
  computed: {
    isButtonEnabled() {
      return (
        this.form.rname &&
        this.form.email &&

        this.form.verifyCode &&
        this.form.password &&
        this.form.confirmPassword &&
        this.form.company &&
        this.form.city &&
        this.form.position &&
        this.form.workDuration &&
        this.form.password === this.form.confirmPassword
      );
    },
    isPhoneValid() {
      const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      return emailRegex.test(this.form.email);
    },
  },
  methods: {
    jumpTo(url) {
      this.$router.push(url);
    },
    // 获取验证码
    getCode() {

      // 先校验邮箱格式
      if (!this.isPhoneValid) {
        Message.error("Please enter the correct email format");
        return;
      }
      getEnglishCaptcha(this.form).then(res => {
        if (res.code === 200) {
          Message.success(res.message);
          this.startCountdown();
        } else {
          Message.error(res.message);
        }
      })
    },
    // 获取验证码倒计时
    startCountdown() {
      this.isCountingDown = true;
      let timer = setInterval(() => {
        this.countdown--;
        if (this.countdown === 0) {
          clearInterval(timer);
          this.isCountingDown = false;
          this.countdown = 60;
        }
      }, 1000);
    },
    // 姓名校验
    checkZh(str) {
      // ^[A-Za-z]+$ ：仅字母，至少 2 个字符
      let reg = /^[A-Za-z]{2,20}$/; 
      return reg.test(str);
    },

    // 公司名称校验
    checkZhCompany(str) {
     // 允许字母、空格、& . ( ) / - ，至少 2 个字符
     let reg = /^[A-Za-z&\/\.\(\) -]{2,}$/; 
  return reg.test(str);
    },

    // 验证码校验（假设为6位数字）
    checkVerifyCode(str) {
      let reg = /^\d{6}$/;
      return reg.test(str);
    },

    // 职位校验（至少2个字符，可以是中英文）
    checkPosition(str) {
      let reg = /^.{2,}$/;
      return reg.test(str);
    },
  // 密码校验
    checkPassword(str) {
      return str.length >= 6;
    },
    // 城市校验
    checkCity(str) {
      //允许字母、空格、'-'（如 New York、San Francisco）
      let reg = /^[A-Za-z -]{2,}$/; 
      return reg.test(str);
    },
    // 统一表单校验方法
    validateForm() {
      const errors = [];
      // 收集所有错误
      if (!this.form.rname.trim())
        errors.push("Please enter your name.");
      if (!this.isPhoneValid) errors.push("The email format is incorrect, please re-enter");

      if (this.form.verifyCode && !this.checkVerifyCode(this.form.verifyCode))
        errors.push("Please enter a 6-digit verification code");
      if (this.form.password && !this.checkPassword(this.form.password))
        errors.push("The password length should be at least 6 digits");
      if (this.form.password !== this.form.confirmPassword)
        errors.push("Entered passwords differ!");
      if (!this.form.company.trim())
        errors.push("Please enter your company.");
      if (!this.form.city.trim()) errors.push("Please enter the city");
      if (!this.form.position.trim())
        errors.push("Please enter your job");
      if (!this.form.workDuration)
        errors.push("Please choose seniority");
      // 延迟显示错误
      if (errors.length > 0) {
        errors.forEach((msg, index) => {
          setTimeout(() => {
            Message.error(msg);
          }, 500 * index);
        });
        return false;
      }

      return true;
    },
    handleSubmit() {
      // 执行完整表单校验
      if (!this.validateForm()) {
        return;
      }
      adminRegister(this.form).then(res => {
        if (res.code === 200) {
          Message.success(res.message);
          this.$router.push("/en/login");
        } else {
          Message.error(res.message);
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.mobile_register {
  width: 100%;
  min-height: 100vh;
  background: url("https://download.hecoos.com/enlightv/2025-19/b946e97c082f040312c95a399d847c29.png");
  background-size: cover;
  background-repeat: no-repeat;
  object-fit: cover;
  // background-color: #d0cad4;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 30px;

  .mobile_register_content {
    width: 100%;
    max-width: 370px;
    background-color: #222222;
    padding: 20px;
    border-radius: 6px;
    text-align: center;

    h2{
      font-size: 24px;
      color: #fff;
      margin-bottom: 15px;
    }

    h3 {
      font-size: 16px;
      font-weight: 300;
      color: #fff;
      margin-bottom: 15px;
    }

    input {
      display: block;
      width: 100%;
      font-size: 14px;
      padding: 12px 8px;
      border-radius: 6px;
      border: none;
      // margin: 0 10px;
      margin-bottom: 10px;
      background-color: #333333;
      color: #fff;

      //&:last-of-type {
      //  margin-bottom: 0;
      //}
    }
    select {
      display: block;
      width: 100%;
      font-size: 14px;
      padding: 12px 8px;
      border-radius: 6px;
      border: none;
      // margin: 0 10px;
      margin-bottom: 10px;
      background-color: #333333;
      color: #fff;

    }
    select.none_select {
      color: #757575;
    }
    select:focus-visible{
      border: none;
      outline: none;
    }

    .get_code {
      position: relative;

      .code_inp {
        margin-bottom: 10px;
      }

      .code_btn {
        position: absolute;
        top: 0;
        right: 0;
        width: 30%;
        background-color: #333333 ;
        color: #757575;
        margin: 0;
        font-size: 14px;
        padding: 12px;
      }
    }

    button {
      display: block;
      width: 100%;
      font-size: 18px;
      margin-top: 15px;
      padding: 8px;
      border: none;
      border-radius: 6px;
    }

    p {
      font-size: 16px;
      color: #fff;
      margin-top: 10px;
    }
  }
}
</style>
